"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlowUser = void 0;
const tslib_1 = require("tslib");
const fcl = tslib_1.__importStar(require("@onflow/fcl"));
const react_1 = require("react");
const provider_1 = require("../../provider");
function useFlowUser() {
    const [flowUser, setFlowUser] = (0, react_1.useState)();
    const client = (0, provider_1.useNiftoryClient)();
    const env = client.getEnvironment();
    const params = client.getParams();
    (0, react_1.useMemo)(() => {
        var _a;
        fcl
            .config()
            .put("accessNode.api", env.flowAccessApi) // connect to Flow
            .put("discovery.wallet", (_a = params.walletApi) !== null && _a !== void 0 ? _a : env.walletApi) // use wallet
            // use pop instead of default IFRAME/RPC option for security enforcement
            .put("discovery.wallet.method", "POP/RPC");
        // Sets flowUser whenver it changes
        fcl.currentUser.subscribe(setFlowUser);
    }, []);
    return flowUser;
}
exports.useFlowUser = useFlowUser;
